const timeAtAddress = [
  {
    value: 'less_than_1_month',
    text:  'Menos de 1 mês',
  },
  {
    value: '1_month',
    text:  '1 mês',
  },
  {
    value: '2_months',
    text:  '2 meses',
  },
  {
    value: '3_months',
    text:  '3 meses',
  },
  {
    value: '4_to_6_months',
    text:  '4 a 6 meses',
  },
  {
    value: '7_months_to_1_year',
    text:  '7 a 12 meses',
  },
  {
    value: '1_year_to_2_years',
    text:  '1 ano a 2 anos',
  },
  {
    value: 'more_than_2_years',
    text:  'Mais de 2 anos',
  },
];
export default timeAtAddress;
